module.exports = __webpack_public_path__ + "assets/img/1.328c887d.jpg";